export default "__VITE_ASSET__C6OVxdOF__"